if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData(this.form);
  let quantity = 1;
  const parentContainer = this.form.closest('.prd-card-btn');
  const collectionPageQuantityInput = parentContainer?.querySelector('.quantity-input');
  const productPageQuantityContainer = document.querySelector('.quantity-selector-buy-button');
  const productPageQuantityInput = productPageQuantityContainer?.querySelector('.quantity__input');
  if (collectionPageQuantityInput) {
    quantity = parseInt(collectionPageQuantityInput.value, 10) || 1;
  } else if (productPageQuantityInput) {
    quantity = parseInt(productPageQuantityInput.value, 10) || 1;
  }
  if (isNaN(quantity) || quantity < 1) {
    this.handleErrorMessage('Please enter a valid quantity.');
    this.resetSubmitButtonState();
    return;
  }
  formData.set('quantity', quantity);
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
}
handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('template--product')) {
    const checkbox = document.getElementById('private-label');
    const form = document.querySelector('.form');

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        const propertyName = 'properties[Print Label]';
        if (checkbox.checked) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = propertyName;
          input.value = 'Yes';
          input.id = 'private-label-property';
          form.appendChild(input);
        } else {
          const input = document.getElementById('private-label-property');
          if (input) {
            input.remove();
          }
        }
      });
    } else {
      console.error('Checkbox with ID "private-label" not found on the product page.');
    }
  } else {
    console.log('Not a product page, skipping script.');
  }
});

